export default __webpack_public_path__ + "static/media/tap_button_normal.c80ec9cd.png";